module.exports = __webpack_public_path__ + "assets1783936157458/img/error-404.94756dcf.svg";